/**
 * PAWWOW - Globale Massbox
 *
 * Seitenbasiertes Widget: Kunde gibt eine Hunderasse ein, das Widget ermittelt die
 * passende Größe (S/M/L ...) aus den globalen "pawwow_groesse"-Metaobjekten und zeigt
 * die Hundebetten der konfigurierten Collection in der passenden Größenvariante an.
 *
 * - Klick auf eine Karte öffnet product.url?variant=<id> (Variante vorausgewählt).
 * - Optionaler "In den Warenkorb"-Button legt die passende Variante direkt in den Warenkorb
 *   (Muster aus paw-wow-bundle.js: cart/add.js + "cart:refresh"-Event).
 */
(function () {
  'use strict';

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function lev(a, b) {
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      for (j = 0; j <= n; j++) prev[j] = cur[j];
    }
    return prev[n];
  }

  function sizeLetter(s) {
    var m = (s || '').toUpperCase().match(/\b(XXL|XXS|XL|XS|S|M|L)\b/);
    return m ? m[1] : null;
  }

  function scoreMatch(nq, nb) {
    if (!nb) return null;
    if (nq === nb) return 0;
    if (nb.indexOf(nq) >= 0 || nq.indexOf(nb) >= 0) return 1;
    var qt = nq.split(' '), bt = nb.split(' '), best = null;
    qt.forEach(function (q) {
      if (q.length < 3) return;
      bt.forEach(function (t) {
        if (t.length < 3) return;
        if (t.indexOf(q) >= 0 || q.indexOf(t) >= 0) { best = (best == null) ? 2 : Math.min(best, 2); return; }
        var d = lev(q, t);
        var tol = Math.max(1, Math.floor(Math.max(q.length, t.length) / 4));
        if (d <= tol) { var s = 2 + d; best = (best == null) ? s : Math.min(best, s); }
      });
    });
    if (best != null) return best;
    var dd = lev(nq, nb);
    var tt = Math.max(2, Math.floor(nb.length / 4));
    if (dd <= tt) return 5 + dd;
    return null;
  }

  function escHtml(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var CART_SVG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 4h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h8.7a1.5 1.5 0 0 0 1.5-1.2L21 8H6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9.5" cy="20.5" r="1.4" fill="currentColor"/><circle cx="17.5" cy="20.5" r="1.4" fill="currentColor"/></svg>';
  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); });
  }

  class PawWowGlobaleMassbox extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.showAtc = this.dataset.showAtc === 'true';
      this.hideSoldOut = this.dataset.hideSoldOut === 'true';
      this.emptyText = this.dataset.emptyText || 'Für diese Hunderasse haben wir leider kein passendes Hundebett gefunden.';

      this.input = this.querySelector('[data-pw-gm-input]');
      this.suggest = this.querySelector('[data-pw-gm-suggest]');
      this.findBtn = this.querySelector('[data-pw-gm-find]');
      this.msg = this.querySelector('[data-pw-gm-msg]');
      this.results = this.querySelector('[data-pw-gm-results]');
      this.resultsHead = this.querySelector('[data-pw-gm-results-head]');
      this.grid = this.querySelector('[data-pw-gm-grid]');

      if (!this.input || !this.grid) return;

      this._buildData();
      this._bindEvents();

      this.activeIndex = -1;
      this.currentMatches = [];
      this._busy = false;
    }

    _parseJson(selector) {
      var el = this.querySelector(selector);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    _buildData() {
      var breedsRaw = this._parseJson('[data-pw-gm-breeds]') || [];
      var productsRaw = this._parseJson('[data-pw-gm-products]') || [];

      // Rassen-Index: pro Rasse Name + normalisierte Form + Größenbuchstabe.
      this.breeds = [];
      var seen = {};
      breedsRaw.forEach(function (entry) {
        var letter = sizeLetter(entry.groesse);
        (entry.rassen || []).forEach(function (raw) {
          raw = (raw || '').trim();
          if (!raw) return;
          var key = norm(raw);
          if (seen[key]) return;
          seen[key] = true;
          this.breeds.push({ raw: raw, norm: key, letter: letter, groesse: entry.groesse || '' });
        }, this);
      }, this);
      this.breeds.sort(function (a, b) { return a.raw.localeCompare(b.raw, 'de'); });

      // Produkte mit aufbereiteten Varianten (Größenbuchstabe je Variante).
      this.products = productsRaw.map(function (p) {
        var variants = (p.variants || []).map(function (v) {
          return {
            id: v.id,
            size: v.size || '',
            letter: sizeLetter(v.size),
            available: !!v.available,
            price_formatted: v.price_formatted || ''
          };
        });
        return { id: p.id, title: p.title, url: p.url, image: p.image, variants: variants };
      });
    }

    _bindEvents() {
      var self = this;
      this.input.addEventListener('input', function () { self._openSuggest(); });
      this.input.addEventListener('focus', function () { self._openSuggest(); });
      this.input.addEventListener('keydown', function (e) { self._onKeydown(e); });

      if (this.suggest) {
        this.suggest.addEventListener('mousedown', function (e) {
          var li = e.target.closest('li[role="option"]');
          if (!li) return;
          e.preventDefault();
          self._chooseSuggestion(parseInt(li.getAttribute('data-i'), 10));
        });
      }

      if (this.findBtn) {
        this.findBtn.addEventListener('click', function () { self._closeSuggest(); self._doFind(); });
      }

      document.addEventListener('click', function (e) {
        if (!self.contains(e.target)) self._closeSuggest();
        else if (e.target !== self.input && !(self.suggest && self.suggest.contains(e.target))) self._closeSuggest();
      });

      this.grid.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-pw-gm-atc]');
        if (!btn) return;
        e.preventDefault();
        self._addToCart(btn);
      });
    }

    /* ---------------------------- Matching ---------------------------- */

    _findMatch(q) {
      var nq = norm(q);
      if (!nq) return null;
      var best = null;
      this.breeds.forEach(function (b) {
        var score = scoreMatch(nq, b.norm);
        if (score != null && (best === null || score < best.score)) {
          best = { breed: b, score: score };
        }
      });
      return best ? best.breed : null;
    }

    _productsForLetter(letter) {
      if (!letter) return [];
      var hideSoldOut = this.hideSoldOut;
      var out = [];
      this.products.forEach(function (p) {
        var available = null, fallback = null;
        p.variants.forEach(function (v) {
          if (v.letter !== letter) return;
          if (v.available && !available) available = v;
          if (!fallback) fallback = v;
        });
        var variant = hideSoldOut ? available : (available || fallback);
        if (variant) out.push({ product: p, variant: variant });
      });
      return out;
    }

    /* ---------------------------- Suche ausführen ---------------------------- */

    _doFind() {
      var q = this.input.value;
      if (!norm(q)) { this.input.focus(); return; }
      this._clearFeedback();

      var breed = this._findMatch(q);
      if (!breed || !breed.letter) {
        this._showError(this.emptyText);
        return;
      }

      var matches = this._productsForLetter(breed.letter);
      if (!matches.length) {
        this._showError(this.emptyText);
        return;
      }

      this._renderResults(breed, matches);
    }

    _renderResults(breed, matches) {
      var head = 'Passende Größe für <strong>' + escHtml(breed.raw) + '</strong>: <strong>Größe ' + escHtml(breed.letter) + '</strong>';
      this.resultsHead.innerHTML = head;

      var showAtc = this.showAtc;
      var html = matches.map(function (m, i) {
        var p = m.product, v = m.variant;
        var href = p.url + (p.url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + v.id;
        var badge = '<span class="pw-gm__card-badge">Größe ' + escHtml(v.letter || breed.letter) + '</span>';
        var media = p.image
          ? '<div class="pw-gm__card-media">' + badge + '<img src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" loading="lazy"></div>'
          : '<div class="pw-gm__card-media pw-gm__card-media--empty">' + badge + '<span aria-hidden="true">🐾</span></div>';

        var priceLine = v.available
          ? '<p class="pw-gm__card-price">' + (v.price_formatted || '') + '</p>'
          : '<p class="pw-gm__card-soldout">Ausverkauft</p>';

        var card = '';
        card += '<article class="pw-gm__card" style="animation-delay:' + (i * 45) + 'ms">';
        card +=   '<a class="pw-gm__card-link" href="' + escHtml(href) + '">';
        card +=     media;
        card +=     '<div class="pw-gm__card-body">';
        card +=       '<h3 class="pw-gm__card-title">' + escHtml(p.title) + '</h3>';
        card +=       priceLine;
        card +=     '</div>';
        card +=   '</a>';
        if (showAtc && v.available) {
          var atcLabel = 'Größe ' + escHtml(v.letter || breed.letter) + ' – In den Warenkorb';
          card += '<button type="button" class="pw-gm__card-atc" data-pw-gm-atc data-variant="' + v.id + '">' + CART_SVG + '<span>' + atcLabel + '</span></button>';
        }
        card += '</article>';
        return card;
      }).join('');

      this.grid.innerHTML = html;
      this.results.hidden = false;
    }

    /* ---------------------------- Warenkorb ---------------------------- */

    _addToCart(btn) {
      if (this._busy) return;
      var variantId = parseInt(btn.getAttribute('data-variant'), 10);
      if (!variantId) return;

      this._busy = true;
      btn.disabled = true;
      var label = btn.querySelector('span');
      var original = label ? label.textContent : '';
      if (label) label.textContent = 'Wird hinzugefügt …';

      var self = this;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (resp) {
        if (!resp.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        btn.classList.add('is-done');
        btn.innerHTML = CHECK_SVG + '<span>Im Warenkorb</span>';
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.disabled = false;
          btn.innerHTML = CART_SVG + '<span>' + original + '</span>';
          self._busy = false;
        }, 2000);
      }).catch(function () {
        if (label) label.textContent = original;
        btn.disabled = false;
        self._busy = false;
      });
    }

    /* ---------------------------- Feedback ---------------------------- */

    _showError(text) {
      if (this.results) this.results.hidden = true;
      if (this.grid) this.grid.innerHTML = '';
      if (!this.msg) return;
      this.msg.textContent = text;
      this.msg.classList.add('pw-gm__msg--error');
      this.msg.hidden = false;
    }

    _clearFeedback() {
      if (this.msg) { this.msg.hidden = true; this.msg.textContent = ''; this.msg.classList.remove('pw-gm__msg--error'); }
    }

    /* ---------------------------- Vorschlags-Dropdown ---------------------------- */

    _highlight(raw, nq) {
      if (!nq) return escHtml(raw);
      var nraw = norm(raw);
      var pos = nraw.indexOf(nq);
      if (pos < 0) return escHtml(raw);
      return escHtml(raw.slice(0, pos)) + '<mark>' + escHtml(raw.slice(pos, pos + nq.length)) + '</mark>' + escHtml(raw.slice(pos + nq.length));
    }

    _openSuggest() {
      if (!this.suggest || !this.breeds.length) { this._closeSuggest(); return; }
      var nq = norm(this.input.value);
      var matches;
      if (!nq) {
        matches = this.breeds.slice(0, 50);
      } else {
        var starts = [], contains = [];
        this.breeds.forEach(function (b) {
          var p = b.norm.indexOf(nq);
          if (p === 0) starts.push(b);
          else if (p > 0) contains.push(b);
        });
        matches = starts.concat(contains).slice(0, 50);
      }
      this.currentMatches = matches;
      this.activeIndex = -1;

      var self = this;
      var html;
      if (!matches.length) {
        html = '<li class="pw-gm__suggest-empty" role="presentation">Keine passende Rasse gefunden</li>';
      } else {
        html = matches.map(function (b, i) {
          return '<li role="option" id="pw-gm-opt-' + i + '" data-i="' + i + '">' + self._highlight(b.raw, nq) + '</li>';
        }).join('');
      }
      this.suggest.innerHTML = html;
      this.suggest.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    _closeSuggest() {
      if (!this.suggest) return;
      this.suggest.hidden = true;
      this.suggest.innerHTML = '';
      this.activeIndex = -1;
      this.currentMatches = [];
      this.input.setAttribute('aria-expanded', 'false');
    }

    _setActive(i) {
      var items = this.suggest ? this.suggest.querySelectorAll('li[role="option"]') : [];
      if (!items.length) return;
      if (i < 0) i = items.length - 1;
      if (i >= items.length) i = 0;
      this.activeIndex = i;
      Array.prototype.forEach.call(items, function (el, idx) {
        if (idx === i) { el.classList.add('is-active'); el.scrollIntoView({ block: 'nearest' }); }
        else { el.classList.remove('is-active'); }
      });
      this.input.setAttribute('aria-activedescendant', 'pw-gm-opt-' + i);
    }

    _chooseSuggestion(i) {
      if (i < 0 || i >= this.currentMatches.length) return;
      this.input.value = this.currentMatches[i].raw;
      this._closeSuggest();
      this._doFind();
    }

    _onKeydown(e) {
      var open = this.suggest && !this.suggest.hidden;
      if (e.key === 'ArrowDown') {
        if (!open) { this._openSuggest(); return; }
        e.preventDefault(); this._setActive(this.activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        if (!open) return;
        e.preventDefault(); this._setActive(this.activeIndex - 1);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (open && this.activeIndex >= 0) { this._chooseSuggestion(this.activeIndex); }
        else { this._closeSuggest(); this._doFind(); }
      } else if (e.key === 'Escape') {
        this._closeSuggest();
      }
    }
  }

  if (!window.customElements.get('pw-globale-massbox')) {
    window.customElements.define('pw-globale-massbox', PawWowGlobaleMassbox);
  }
})();
